import React from "react";
import DashboardComingSoon from "./DashboardComingSoon";
import App1Dashboard from "./app1/Dashboard";
import App2Dashboard from "./app2/Dashboard";

function DashboardRouter() {
  const applicationId = Number(process.env.REACT_APP_APPLICATION_ID || 0);

  const dashboardMap = {
    1: <App1Dashboard />,
    2: <App2Dashboard />,
  };

  return dashboardMap[applicationId] || <DashboardComingSoon />;
}

export default DashboardRouter;
